define('NewsLetterForm.View'
,	[
		'tavanoteam_newsletterform_newsletterform.tpl'
	,	'Backbone.FormView'	
	,	'Backbone.CompositeView'
	,	'TavanoTeam.NewsLetterForm.Model'
	,	'NewsLetterForm.Confirmation.View'	
	,	'Backbone.CollectionView'
	,	'SC.Configuration'
	,	'Utils'
	,	'jQuery'
	,	'underscore'
	,	'GlobalViews.Message.View'
	]
,	function (
	tavanoteam_newsletterform_newsletterform
	,	BackboneFormView
	,	BackboneCompositeView	
	,	NewsLetterFormModel
	,	NewsLetterFormConfirmationView
	,	BackboneCollectionView	
	,	Configuration
	,	Utils
	,	jQuery
	,	_
	,	GlobalViewsMessageView
	)
{
	'use strict';

	return Backbone.View.extend({

		template: tavanoteam_newsletterform_newsletterform
		,	
	
		initialize: function (options) {
			BackboneCompositeView.add(this);
			this.model = new NewsLetterFormModel();
			var self = this;
			
			this.model.fetch({
				data: { id: 204 }
			})
			.done(function(response) {
				self.render();
			});

			//Get Components
			this.application = options.application;
			var environment = this.application.getComponent('Environment');

			//Get ReCaptcha Configuration
			this.siteKey = environment.getConfig('TTCaptchaKeysV3.siteKey');
			this.javascriptAPIUrl = environment.getConfig('TTCaptchaKeysV3.javascriptAPIUrl');
			this.enableLogs = environment.getConfig('TTCaptchaKeysV3.enableLogs');
			this.enableRecaptcha = this.siteKey && this.javascriptAPIUrl;

			//Load ReCaptcha
			window.grecaptcha = _.bind(this.render, this);
			this.loadRecaptchaScript(this.siteKey, this.javascriptAPIUrl);
			this.captchaPromise = jQuery.getScript(this.javascriptAPIUrl);

			BackboneFormView.add(this);  
			this.model.on('save', jQuery.proxy(this, 'manageResponse'));

		},
		bindings: {
				'[name="firstname"]': 'firstname'
			,	'[name="lastname"]': 'lastname'
			,	'[name="email"]': 'email'
			,	'[name="comments"]': 'comments'
			,	'[name="city"]': 'city'
			,	'[name="company"]': 'company'
			,	'[name="phone"]': 'phone'	
			,	'[name="industry"]': 'industry'	
			,	'[name="annual_sales"]': 'annual_sales'	
			,	'[name="state"]': 'state'	
			,	'[name="salealerts"]': 'salealerts'	
			,	'[name="quarterly"]': 'quarterly'	
		},

		events: {
			'submit form': 'validateForm'
		},


		showSuccess : function showSuccess() {
			var layout = this.application.getLayout();
			var loyalityConfView = new NewsLetterFormConfirmationView({});
			layout.showInModal(loyalityConfView,{});
		},

		manageResponse : function showSuccess(model) {
			
			var targetEl = '#grecaptcha-error-message';

			if (model.get("status") == 500){

				//Show Recaptcha Error Message
				var messageView = new GlobalViewsMessageView({
					errorCode: 'ERR_RECAPTCHA_INVALID',
					message: model.get("message"),
					type: 'error',
					closable: true
				});
				
				this.$(targetEl).show();
				this.$(targetEl).html(messageView.render().$el);

			} else {

				//Show Success Message
				this.$(targetEl).hide();
				this.showSuccess();
			}
		},

		render: function(){
			
			Backbone.View.prototype.render.apply(this, arguments);
		
		},
		
		submitForm: function (e) {
		
			BackboneFormView.saveForm.apply(this, arguments);

		},

		validateForm: function(e){

			var self = this;

			if(this.enableRecaptcha && this.captchaPromise.state() === 'resolved'){

				try {

					e.preventDefault();

					var gRecaptcha = grecaptcha || window.grecaptcha
					,   promise = jQuery.Deferred()
					,   grecaptchaRes = {};

					gRecaptcha.ready(function()
					{
						gRecaptcha.execute(self.siteKey, {action:'newsletterForm'})
						.then(function(token)
						{
		
							if(self.enableLogs) {
								console.log("gRecaptcha Token", token);
							}

							//Set Token
							self.model.set('token', token);

							//Submit Form
							self.submitForm(e);
							
						})
					});
				} catch (err) {
					console.log('Error rendering recaptcha: ', err);
				}
			} else {
				
				//Submit Form
				this.submitForm(e);

			}

		},

		loadRecaptchaScript: function loadRecaptchaScript(siteKey, javascriptAPIUrl){
			
			var script = document.createElement('script');

			script.type = "text/javascript";
			script.src = javascriptAPIUrl + siteKey;
			script.defer = true;

			jQuery('head').append(script);
			
		},

		defineValues: function defineValues(list, isState){
			var ret = [];
			if(!isState){
				_.each(list,function(element, i){
					var elementInfo = {
						internalId: element.valueid,
						isActive: false,
						label: element.value
					}
					ret.push(elementInfo);
				})
			}else{
				_.each(list,function(element, i){
					var elementInfo = {
						internalId: element.code,
						isActive: false,
						label: element.name
					}
					ret.push(elementInfo);
				})
			}
			
			return ret;
		},

		getContext: function getContext()
		{
			var self = this;
			var industry = self.model.attributes.industry ? this.defineValues(self.model.attributes.industry) : "";
			
			return {
			 	 industrySelectValues: industry,
			};
		}

	});
});
